import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars

import {autobind} from 'core-decorators';

import {Link} from '../../../common/components';
import {Icon} from '../../../common/components/Icon';

import './Banner.scss';
import 'animate.css/source/attention_seekers/pulse.css';


export class Banner extends Component<jsx.Props, jsx.State> {
    assets = {
        mp4: '/assets/img/api/gif-search-animation.mp4',
    };
    searchTerms = [`Hello there`, `Let's party`, `Oh wow!`];
    videoSectionLength = 6;
    videoSkipTo = [0, 6, 12];
    settings = {
        typingSpeed: .10,
        deleteSpeed: .03,
        completionPause: 3.0,
        deletionPause: .5,
        restartAnimationTimer: 5,
    };
    timer?: ReturnType<typeof setTimeout>;
    video?: HTMLVideoElement|null;

    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            typing: false,
            deleting: false,
            pausedAfterTyping: false,
            pausedAfterDeletion: false,
            fadeIn: false,

            currentTermIdx: 0,
            currentLetterIdx: 0,
            clicked: false,
            isAnimating: true,
            pausedTime: 0,
            searchText: '',
        };
    }

    componentDidMount() {
        this.animateTyping();
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    @autobind
    toggleAnimation() {
        if (this.state.isAnimating) {
            this.video?.pause();
            clearInterval(this.timer);
            this.fadeInOutGoToDocs();
            this.timer = setTimeout(this.toggleAnimation,
                this.settings.restartAnimationTimer * 1000);
        } else {
            this.video?.play();
            this.resumeAnimation();
        }
        this.setState({
            isAnimating: !this.state.isAnimating,
        });
    }

    fadeInOutGoToDocs() {
        this.setState({
            fadeIn: true,
        });
        setTimeout(
            () => {
                return this.setState({fadeIn: false});
            }, this.settings.restartAnimationTimer * 1000 - 400,
        );
    }

    @autobind
    animateTyping() {
        this.setState({
            typing: true,
        });
        this.timer = setInterval(this.tick, this.settings.typingSpeed * 1000);
    }

    @autobind
    animateDeleting() {
        this.setState({
            deleting: true,
        });
        this.timer = setInterval(this.tick, this.settings.deleteSpeed * 1000);
    }

    resumeAnimation() {
        if (this.state.typing) {
            this.animateTyping();
        } else if (this.state.deleting) {
            this.animateDeleting();
        } else if (this.state.pausedAfterTyping ||
                this.state.pausedAfterDeletion) {
            this.startTimer();
        }
    }

    startTimer() {
        this.timer = setInterval(this.tick, 100);
    }

    animatePause() {
        if (this.state.typing) {
            this.video.currentTime = this.videoSkipTo[
                this.state.currentTermIdx];
            this.video?.play();
            this.setState({
                typing: false,
                pausedAfterTyping: true,
            }, this.startTimer );
        } else if (this.state.deleting) {
            this.changeSearchTerm();
            this.setState({
                deleting: false,
                pausedAfterDeletion: true,
            }, this.startTimer );
        }
    }

    @autobind
    changeSearchTerm() {
        let currentTermIdx;
        if (this.state.currentTermIdx === this.searchTerms.length - 1) {
            currentTermIdx = 0;
        } else {
            currentTermIdx = this.state.currentTermIdx + 1;
        }
        this.setState({
            currentTermIdx,
            currentLetterIdx: 0,
            searchText: '',
        });
    }

    @autobind
    tick() {
        if (this.state.typing || this.state.deleting) {
            const currentTerm = this.searchTerms[this.state.currentTermIdx];
            let tick;
            let stillTyping;
            if (this.state.typing) {
                tick = 1;
                stillTyping = this.state.searchText.length < currentTerm.length;
            } else {
                tick = -1;
                stillTyping = this.state.searchText.length > 0;
            }
            if (stillTyping) {
                this.setState({
                    currentLetterIdx: this.state.currentLetterIdx + tick,
                    searchText: currentTerm.slice(
                        0, this.state.currentLetterIdx + tick),
                });
            } else {
                clearInterval(this.timer);
                this.animatePause();
            }
        } else if (this.state.pausedAfterTyping) {
            if (this.state.pausedTime <= this.settings.completionPause * 10) {
                this.setState({
                    pausedTime: this.state.pausedTime + 1,
                });
            } else {
                this.setState({
                    pausedTime: 0,
                    pausedAfterTyping: false,
                });
                clearInterval(this.timer);
                this.animateDeleting();
            }
        } else if (this.state.pausedAfterDeletion) {
            if (this.state.pausedTime <= this.settings.deletionPause * 10) {
                this.setState({
                    pausedTime: this.state.pausedTime + 1,
                });
            } else {
                this.setState({
                    pausedTime: 0,
                    pausedAfterDeletion: false,
                });
                clearInterval(this.timer);
                this.animateTyping();
            }
        }
    }


    @autobind
    handleClick() {
        this.toggleAnimation();
    }

    renderSearchBar() {
        if (this.state.isAnimating) {
            return (
                <div className={'search-animation'}>
                    <div className="searchbar-left">
                    </div>
                    <div className={'text'}>
                        {this.state.searchText}
                        <span className={`cursor${this.state.typing ? '' : ' blink'}`}>|</span>
                    </div>
                    <div className={'searchbar-right'}>
                        <Icon
                            name="search"
                            className={(this.state.pausedAfterTyping ? ' animate-pulse' : '')}/>
                    </div>
                </div>
            );
        } else {
            return (
                <Link
                    to={'/gifapi/documentation'}
                    clickLabel="api-home-searchbar-cta"
                    className={`search-paused${this.state.fadeIn ? ' fade-in' : ' fade-out'}`}>
                    <span className="text">Go to the API docs</span>
                    <Icon name="chevron-right"/>
                </Link>
            );
        }
    }

    render() {
        return (
            <div id="banner">
                <div className="video-container">
                    <div className="video-crop">
                        <video
                            muted={true}
                            playsInline={true}
                            ref={(ref) => {
                                return this.video = ref;
                            }}
                            loop={true}
                        >
                            <source src={this.assets.mp4} type="video/mp4" />
                            Your browser does not support the video tag. I
                            suggest you upgrade your browser.
                        </video>
                    </div>
                </div>
                <div className="video-filter"/>

                <div className="content-container">
                    <div className="search-bar" onClick={this.handleClick}>
                        {this.renderSearchBar()}
                    </div>
                    <div className="blurb">
                        <h3>
                            Tenor Search delivers the world&apos;s most
                            relevant and engaging GIFs. Access it now for free.
                        </h3>
                    </div>
                    <Link
                        className="white-button"
                        to="https://developers.google.com/tenor/guides/quickstart"
                        clickLabel="api-home-banner-cta">
                        Go to the Docs
                    </Link>
                    <Link
                        className="white-button"
                        to="/gifapi/documentation"
                        clickLabel="api-home-banner-cta">
                        Click here for legacy V1 documentation
                    </Link>
                </div>
            </div>
        );
    }
}
